<template>
  <div
    style="
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    <div
      style="
        font-size: 22px;
        width: 300px;
        text-align: center;
        margin-bottom: 20px;
      "
    >
      授权后，体验更多功能！
    </div>
    <div
      style="
        background-color: #07c160;
        width: 200px;
        height: 50px;
        border-radius: 80px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 20px;
        font-weight: 500;
      "
      @click="onLogin"
    >
      直接授权
    </div>
  </div>
</template>
<script>
import request from "@/api/index";
export default {
  data() {
    return {};
  },
  mounted() {
    //     console.log(window.location.href);
    // const redirectUrl = decodeURIComponent(this.$route.query.url);
    // console.log(redirectUrl);
  },
  methods: {
    async onLogin() {
      const redirectUrl = decodeURIComponent(this.$route.query.url);
      // 发起授权请求
      let url = redirectUrl;
      let local = encodeURIComponent(url); //获取当前页面地址作为回调地址
      let appid = "wx790c119c911e7aa5";
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appid +
        "&redirect_uri=" +
        local +
        "&response_type=code&scope=snsapi_userinfo&state=7498ab0f-0adb-406d-b654-44371573dfef#wechat_redirect";
    },
  },
};
</script>